import { useState } from "react";
import { ArrowUpRight, List, X } from "react-bootstrap-icons";

export const NavBar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header">
      <div className="page-shell nav-inner">
        <a
          className="wordmark"
          href="#home"
          aria-label="Aaron Zhang, home"
          onClick={() => setOpen(false)}
        >
          aaron<span>.</span>
        </a>
        <button
          className="menu-toggle"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="main-navigation"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={25} /> : <List size={25} />}
        </button>
        <nav
          id="main-navigation"
          className={open ? "main-navigation is-open" : "main-navigation"}
          aria-label="Main navigation"
        >
          <a href="#experiences" onClick={() => setOpen(false)}>
            Experience
          </a>
          <a href="#projects" onClick={() => setOpen(false)}>
            Projects
          </a>
          <a href="#skills" onClick={() => setOpen(false)}>
            Expertise
          </a>
          <a
            className="nav-contact"
            href="#connect"
            onClick={() => setOpen(false)}
          >
            Let’s talk <ArrowUpRight aria-hidden="true" />
          </a>
        </nav>
      </div>
    </header>
  );
};
